<template>
    <div class="quantity">
        <b-input-group>
            <b-input-group-prepend>
                <b-button variant="primary" @click="decrement()" type="button">
                    <font-awesome-icon :icon="['fas', 'minus']" />
                </b-button>
            </b-input-group-prepend>
            <b-input 
                :name="inputName" 
                type="number"
                :min="minValue"
                :max="maxValue"
                v-model="inputValue"
                disabled
            />
            <b-input-group-append>
                <b-button variant="primary" @click="increment()" type="button">
                    <font-awesome-icon :icon="['fas', 'plus']" />
                </b-button>
            </b-input-group-append>
        </b-input-group>
    </div>
</template>
<script>
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { 
    faPlus,
    faMinus,
    } from '@fortawesome/free-solid-svg-icons'

    library.add(faPlus)
    library.add(faMinus)

    export default {
        name: "Quantity",
        props: ['inputName', 'inputValue', 'minValue', 'maxValue'],
        data() {
            return {
                quantity: 0,
            }
        },
        methods: {
            increment() {
                if (this.inputValue >= this.maxValue) {
                    //alert("Quantity not allowed");
                } else {
                    this.inputValue++;
                    this.$emit("child-quantity", this.inputValue);
                }
            },
            decrement() {
                if (this.inputValue <= this.minValue) {
                    //alert("Negative quantity not allowed");
                } else {
                    this.inputValue--;
                    this.$emit("child-quantity", this.inputValue);
                }
            }
        }
    };
</script>
<style scoped>
    .quantity {
        max-width: 140px;
        width: 100%;
    }

    .quantity input {
        text-align: center;
    }
    .quantity input::-webkit-outer-spin-button,
    .quantity input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
        /* Chrome */
      }
    .quantity input[type=number] {
        -moz-appearance: textfield;
        /* Firefox */
      }
</style>